export function getTimeDifference(matchTime: string, matchDate: string): any {
  let timeDifference = 0;
  if(matchTime){
    const now = new Date();
    const matchDateTime = new Date(matchDate);
    timeDifference = matchDateTime.getTime() - now.getTime();
  }
  return timeDifference;
  }